import {BOOKING_STATUS, BOOKING_STATUS_LABEL, PAYMENT_METHOD} from "../../common/constants";

/** Status-specific badge class for bright, distinct colors (badge-status-pending, etc.) */
export const getStatusBadgeClass = (status) => {
  switch (status) {
    case BOOKING_STATUS.PENDING:
      return 'badge-status-pending';
    case BOOKING_STATUS.CONFIRMED:
      return 'badge-status-confirmed';
    case BOOKING_STATUS.COMPLETED:
      return 'badge-status-completed';
    case BOOKING_STATUS.DECLINED:
      return 'badge-status-declined';
    case BOOKING_STATUS.CANCELLED:
      return 'badge-status-cancelled';
    default:
      return 'badge-status-default';
  }
};

export const getStatusDisplayLabel = (status) => {
  return BOOKING_STATUS_LABEL[status] ?? status;
};

export const getPaymentMethodDisplay = (paymentMethod) => {
  switch (paymentMethod) {
    case PAYMENT_METHOD.PAY_AT_GROUND:
      return 'Pay at Ground';
    case PAYMENT_METHOD.PAY_ONLINE:
      return 'Online';
    default:
      return paymentMethod;
  }
};